// extracted by mini-css-extract-plugin
module.exports = {"counter":"TextAreaSms_counter__wtCHw","spacer":"TextAreaSms_spacer__f9fjA"};